import { Component, Input } from '@angular/core';
import { RequirementDto } from '../../../../../models/job-unit-requirements.model';

import { UntilDestroy } from '@ngneat/until-destroy';
import { JobQualificationsChangeTypeEnum } from '../../../enums/job-qualifications-change-type.enum';
import { JobQualificationChange } from '../../../models/job-qualification-change.model';
import { NgFor, NgIf } from '@angular/common';

@UntilDestroy()
@Component({
    selector: 'nova-job-qualifications-certs-change',
    templateUrl: './job-qualifications-certs-change.component.html',
    styleUrls: ['./job-qualifications-certs-change.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor]
})
export class JobQualificationsCertsChangeComponent {
    @Input()
    certs: Array<JobQualificationChange<RequirementDto>>;

    changeType = JobQualificationsChangeTypeEnum;
}
